import { render, staticRenderFns } from "./TextboxHavePrice.vue?vue&type=template&id=2c67a5c0&"
import script from "./TextboxHavePrice.vue?vue&type=script&lang=js&"
export * from "./TextboxHavePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports